module.exports = __webpack_public_path__ + "static/media/featured-img.0e5a7808.jpg";